import { callApiToServer } from '../../callApi';

export async function changeGccStatus(
  authtoken,
  countryId,
  status
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };
      
    let body = JSON.stringify({
        countryId: countryId,
        flag: status
    });

    let endUrl = "v1/auth/change-country-gcc-status";
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
  }catch(err) {
    throw err;
  }
}
